<template>
  <CDropdown placement="bottom-end" :toggler-text="title">
    <CDropdownItem v-for="item in items" :key="item.title" @click="onItemClick(item)">
      <CIcon
        name="cil-check-alt"
        height="20"
        alt="Logo"
        :style="{visibility: item.isSelected ? 'visible' : 'hidden'}"
      />
      {{ item.title }}
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  props: {
    title: String,
    items: Array
  },
  methods: {
    onItemClick(selectedItem) {
      for (const item of this.items) {
        item.isSelected = item.key === selectedItem.key;
      }
    }
  }
};
</script>
<style >
.table th {
  border-top: 0px solid;
}
</style>
